import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title } from '@/shared/uikit/Title';
import { Button } from '@/shared/uikitV2/Button';
import { BtnClose } from '@/widgets/modals/components/BtnClose';

type ConfirmCloseProps = {
  text?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmClose: FC<ConfirmCloseProps> = ({ text, onClose, onConfirm }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'uploadFiles' }); // TODO rework namespace

  return (
    <Container>
      <Dialog>
        <BtnClose style={{ position: 'absolute', top: 24, right: 24 }} onClick={onClose} />
        <Title size={22} bold style={{ width: '100%' }}>
          {text ?? t('confirm.title')}
        </Title>
        <Button
          style={{
            width: 150,
            border: `1px solid ${COLORS.systemDark100}`,
            fontSize: 14,
            fontWeight: 700,
            background: COLORS.systemLight100,
            color: COLORS.systemDark300,
          }}
          onClick={onClose}
        >
          {t('confirm.no')}
        </Button>
        <Button
          style={{
            width: 150,
            fontSize: 14,
            fontWeight: 700,
            background: COLORS.systemFlame200,
            color: COLORS.systemLight100,
          }}
          onClick={onConfirm}
        >
          {t('confirm.yes')}
        </Button>
      </Dialog>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  background: rgba(255, 255, 255, 0.72);
`;

const Dialog = styled.div`
  height: 132px;
  padding: 24px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  border-bottom: 1px solid ${COLORS.systemFlame200};
  background: ${COLORS.systemFlame100};
`;
